module.exports = __webpack_public_path__ + "media/52_Long.6ae2901b.mp3";